import { toggleFullScreen } from 'helpers/player';

const shaka = require('external/shaka-player.ui.debug');

const FullscreenButton = class extends shaka.ui.Element {
  constructor(parent: typeof FullscreenButton, controls: ShakaControl) {
    super(parent, controls);

    // The actual button that will be displayed
    this.button_ = document.createElement('button') as HTMLButtonElement;
    this.button_.textContent = 'Fullscreen';
    this.button_.classList.add('shaka-fullscreen-button');

    this.parent.appendChild(this.button_);

    this.eventManager.listen(this.button_, 'click', () => {
      const video = this.player.getMediaElement() as HTMLVideoElement;
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      if (document.pictureInPictureElement) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        document.exitPictureInPicture();
      }
      toggleFullScreen(video);
    });
  }
};

// Factory that will create a button at run time.
FullscreenButton.Factory = class {
  create(rootElement, controls) {
    return new FullscreenButton(rootElement, controls);
  }
};

export default FullscreenButton;
